__turbopack_context__.v({
  "content": "HneNSW_content",
  "descName": "HneNSW_descName",
  "loginButton": "HneNSW_loginButton",
  "loginIcon": "HneNSW_loginIcon",
  "root": "HneNSW_root",
  "secondary": "HneNSW_secondary",
});
